import { InitialApprovalDocMasterAmount } from '.';

export const types = {
  APPROVAL_AMOUNT_SIDEBAR: 'APPROVAL_AMOUNT_SIDEBAR' as const,
};

export const saveApprovalDocumentAmountSideBar = (payload: InitialApprovalDocMasterAmount) => ({
  type: types.APPROVAL_AMOUNT_SIDEBAR,
  payload,
});

export type Actions = (
  | ReturnType<typeof saveApprovalDocumentAmountSideBar>
);
